module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/cleaning-mobile@3x-4fc0dd786729047739e32b7191d61eb1.jpg";